import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CancelIcon from "@mui/icons-material/Cancel";

export default function DeleteUserDialog({ open, onClose, onDelete, user }) {
    const handleDelete = () => {
        onDelete(user);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="xs"
        >
            <DialogTitle>Delete User {user.email}</DialogTitle>
            <DialogContent>
                <Typography>
                    Are you sure you want to delete{" "}
                    <strong>{user ? `${user.fname} ${user.lname}` : ""}</strong>? <br/>
                    *Once deleted this action cannot be undone
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ width: '100%', marginBottom: '5px'}}>
                    <Button
                        variant="contained"
                        color="error"
                        startIcon={<DeleteIcon />}
                        onClick={handleDelete}
                    >
                        Delete
                    </Button>

                    <Button
                        variant="outlined"
                        color="primary"
                        startIcon={<CancelIcon />}
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}